import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import CollectJSContext from '@lydiagoulding/react-nmi-collectjs/lib/esm/contexts/CollectJSContext'
import { makeYupSchemaFrom_required_address_fields } from '@newswebsiteapp/shared/react/AddressFields'

export function useNmiFormRecaptchaModal_onSubmitPrepare({
  collectJS,
  setFormError,
  submittingFinalForm,
  recaptchaSiteKey_disabled,
  recaptchaToken,
  setSubmittingFinalForm,
  lastValidDataRef_formData,
  lastValidDataRef_recaptchaToken,
  formData,

  callback,
}) {
  if (!collectJS) { setFormError('CollectJs is not loaded, reload page'); return }

  if (submittingFinalForm) { return } // Needed?

  if (!recaptchaSiteKey_disabled && !recaptchaToken) {
    setFormError('First pass recaptcha')
    return
  }

  setFormError(null)
  setSubmittingFinalForm(true)

  lastValidDataRef_formData.current = formData
  lastValidDataRef_recaptchaToken.current = recaptchaToken

  return callback()
}

export function useNmiFormRecaptchaModal({ dataFromServer }) {
  // HACK!!!!! I am just lazy to search how to disable the form inputs?
  const lastValidDataRef_formData = React.useRef(null)
  const lastValidDataRef_recaptchaToken = React.useRef(null)

  const recaptchaInstanceRef = React.useRef(null)

  const [modalOpen, setModalOpen] = React.useState(false)
  const [recaptchaToken, setRecaptchaToken] = React.useState(null)
  const [submittingFinalForm, setSubmittingFinalForm] = React.useState(false)
  const [formError, setFormError] = React.useState(null)

  /// ///////////////
  const collectJs_handleTimeout = React.useCallback(() => {
    setFormError("The tokenization of payment data didn't respond in the expected timeframe. This could be due to an invalid or incomplete field or poor connectivity")
    setSubmittingFinalForm(false)
  })

  const formConfig = React.useMemo(() => {
    const schema = makeYupSchemaFrom_required_address_fields(dataFromServer.required_address_fields)
    return {
      resolver: yupResolver(schema),
      defaultValues: dataFromServer.current_user,
    }
  }, [dataFromServer])

  // https://github.com/gmpetrov/databerry/blob/e1d10f258464544fc6304d523e81a4dab61a5c27/apps/dashboard/pages/auth/signin.tsx#L16
  const { control, handleSubmit } = useForm(formConfig)

  const { collectJS } = React.useContext(CollectJSContext)

  return {
    lastValidDataRef_formData,
    lastValidDataRef_recaptchaToken,
    recaptchaInstanceRef,
    modalOpen,
    setModalOpen,
    recaptchaToken,
    setRecaptchaToken,
    submittingFinalForm,
    setSubmittingFinalForm,
    formError,
    setFormError,
    control,
    handleSubmit,
    collectJS,
    collectJs_handleTimeout,
  }
}
